export default __webpack_public_path__ + "static/media/can.20648843.gif";